<div class="expandir">
  <ng-container *ngIf="spinner">
    <app-loading-spinner></app-loading-spinner>
  </ng-container>
  <div class="container" *ngIf="!spinner">
    <div class="p-3">
      <app-search-bar></app-search-bar>
    </div>
    <div class="row mb-3">
      <ng-container *ngFor="let curso of cursosToShow">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-3">
          <app-shared-card
            [curso]="curso"
            (openModalEmitter)="openModal($event)">
          </app-shared-card>
        </div>
      </ng-container>
    </div>

    <!-- Paginación -->
    <nav aria-label="Page navigation">
      <ul class="pagination">
        <li class="page-item" [class.disabled]="currentPage === 1">
          <a class="page-link" (click)="goToPage(1)" aria-label="First">
            <span aria-hidden="true">&laquo;&laquo;</span>
          </a>
        </li>
        <li class="page-item" [class.disabled]="currentPage === 1">
          <a
            class="page-link"
            (click)="goToPage(currentPage - 1)"
            aria-label="Previous">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li
          class="page-item"
          *ngFor="let page of pages"
          [class.active]="currentPage === page">
          <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
        </li>
        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <a
            class="page-link"
            (click)="goToPage(currentPage + 1)"
            aria-label="Next">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <a class="page-link" (click)="goToPage(totalPages)" aria-label="Last">
            <span aria-hidden="true">&raquo;&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>
